import { CircularProgress } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import React from "react";

const useStyles = makeStyles(() => ({
  loading: {
    display: "flex",
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
  },
}));

function Loading({ size, color }) {
  const classes = useStyles();

  return (
    <div className={classes.loading}>
      <CircularProgress size={size} color={color} />
    </div>
  );
}

export default Loading;
